let _hmt = _hmt || [];
(function() {
  let hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?3e643406a64bff0963cd7b6c4f597d34'
  let s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
